import React from 'react';
import { useMsal } from '@azure/msal-react';
import { HeroPanel } from '../components/shared/HeroPanel';

const ClientSelect = () => {
  const { accounts } = useMsal();

  // Rendered only via AuthLayout's <AuthenticatedTemplate>, so this is always the
  // signed-in landing; the unauthenticated hero lives in AuthLayout.
  return (
    <HeroPanel
      subtitle="Pick a destination from the navigation above to get started."
      title={`Welcome${accounts[0]?.name ? `, ${accounts[0].name}` : ''}`}
    />
  );
};

export default ClientSelect;
